import Chip from "@material-ui/core/Chip";
import React from "react";
import OpportunityProductResponse from "../../../../api/models/OpportunityProductResponse";
import {
  OpportunityProductsAutocomplete, //
} from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import StyledTooltip from "../../../../components/Wrapper/StyledTooltip";

interface CustomTagProps {
  data: OpportunityProductResponse;
  disabled: boolean;
  onDelete: () => void;
}

const CustomTag: React.FC<CustomTagProps> = ({
  data,
  disabled,
  onDelete,
  // ! separate unwanted tagProps (disabled, onDelete) to avoid undesired behavior
  ...restTagProps
}) => {
  return (
    <StyledTooltip title={data.nart || ""} {...restTagProps}>
      <Chip label={data.name} />
    </StyledTooltip>
  );
};

interface OpportunityProductsInputProps {
  values: OpportunityProductResponse[];
}

const OpportunityProductsInput: React.FC<OpportunityProductsInputProps> = ({ values }) => {
  return (
    <OpportunityProductsAutocomplete
      disabled
      customTag={CustomTag}
      inputLabel="Opportunity Products"
      map={(data) => ({
        key: data.nart ?? (data.name ? data.name : ""),
        label: data.name ?? "",
      })}
      onChange={() => {}}
      optionFetch={() => {
        return Promise.resolve({
          data: [] as OpportunityProductResponse[],
          totalPages: 0,
        });
      }}
      tagColorSecondary={() => true}
      value={values}
    />
  );
};

export default OpportunityProductsInput;
